export const OFFER_PLURAL_VARIANTS: [string, string, string] = ['предложение', 'предложения', 'предложений'];
